import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import AppContext, { PublishAppContext } from "../../../context/Context";
import APICall from "../../../services/apiCall";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import Loader from "../../common/Loader";

const removeRandomLastString = (str) => {
  let removeRandomString = "";
  if (str.includes("-")) {
    let findDash = str.lastIndexOf("-");
    removeRandomString = str
      .substring(0, findDash)
      .replace(/ /g, "")
      .trim();
  } else {
    removeRandomString = str;
  }

  return { removeRandomString, orignalString: str };
};

const FinalPublish = () => {
  const {
    marketplaceBackgroundImage,
    promotionalImage1,
    promotionalImage2,
    promotionalImage3,
    automaticRegistrationHandshakeIdx,
    description,
    thankYouNote,
    contentConfirmationEmail,
    categoryIndex,
    partnerDetails,
    confirmationImage,
    applicationList,
    selectedApplication,
    partnerlogoImage,
    apiLicenseValue,
    selectedFreshdeskOptionValue,
    needSikkaAppsLicense,
    partnerTagline,
    isEditMode,
    setIsEditMode,
    getApplicationInfomation,
  } = useContext(PublishAppContext);
  const [isClicked, setisClicked] = useState(false);
  

  const { loginUserDetails } = useContext(AppContext);

  const category = [
    "Business Intelligence",
    "Acquire & Retain",
    "Client Financing",
    "Financial Health",
    "Manufacturer and Distributor",
    "Lab Services",
  ];

  const automaticRegistrationHandshake = ["Yes", "No"];

  const handlePublishApplication = () => {
    setisClicked(true);
    const marketPlaceListingValues = JSON.parse(
      sessionStorage.getItem("publish-app-details")
    );
    let partnerId =
      selectedApplication?.publish_app_partner_id ||
      applicationList.find((data) => data.publish_app_partner_id)
        ?.publish_app_partner_id;
    let addBody = {
      dev_id: `${loginUserDetails.parent_dev_id}`, //paret_dev_id
      app_id: `${selectedApplication.app_id}`,
      scrm_account_id: "", //for now blank
      partner_name: `${partnerDetails.partner_name}`, // get from partner_details API
      master_customer_id: `${partnerDetails.master_customer_id}`, // get from partner_details API
      address: `${partnerDetails.dev_address}`, //dev_address from partner_details API
      city: `${partnerDetails.dev_city}`, //dev_city from partner_details API
      state: `${partnerDetails.dev_state}`, //dev_state from partner_details API
      zip_code: `${partnerDetails.dev_zip}`, //dev_zip from partner_details API
      country: `${partnerDetails.dev_country}`, //dev_country from partner_details API
      contact_person_name: `${partnerDetails.dev_name}`, //dev_name from partner_details API
      contact_person_phone: `${partnerDetails.dev_phone}`, //dev_phone from partner_details API
      contact_person_email: `${partnerDetails.username}`, //username from partner_details API
      app_logo: `${selectedApplication.app_logo}`, //get from partner_all_apps
      service_name: `${
        removeRandomLastString(selectedApplication.app_name).removeRandomString
      }`, //app_name from partner_all_apps
      check_out_process: "Registration Only", //hardcoded
      domain_name:
        marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.toString()
          : "", //value should be comma separated
      service_domain:
        marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.length > 0
            ? marketPlaceListingValues.domain[0]
            : ""
          : marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.toString()
          : "", // "if user select multiple domains then first else same as domain_name",
      img_bytes_marketplace_background_image: marketplaceBackgroundImage[0]?.base64?.split(
        ","
      )[1], //Image bytes same as app_logo in add edit application
      img_name_marketplace_background_image:
        marketplaceBackgroundImage[0]?.path, // Image name same as app_logo in add edit application
      img_bytes_promotional1: promotionalImage1[0]?.base64?.split(",")[1],
      img_name_promotional1: promotionalImage1[0]?.path,
      img_bytes_promotional2: promotionalImage2[0]?.base64?.split(",")[1],
      img_name_promotional2: promotionalImage2[0]?.path,
      img_bytes_promotional3: promotionalImage3[0]?.base64?.split(",")[1],
      img_name_promotional3: promotionalImage3[0]?.path,
      terms_of_service: marketPlaceListingValues.termsOfServiceURL
        ? marketPlaceListingValues.termsOfServiceURL
        : "", // IF URL redio button checekd then pass URL else keep it blank
      cancellation_policy: marketPlaceListingValues.cancellationPolicyURL
        ? marketPlaceListingValues.cancellationPolicyURL
        : "", // IF URL redio button checekd then pass URL else keep it blank
      privacy_policy: marketPlaceListingValues.privacyPolicyURL
        ? marketPlaceListingValues.privacyPolicyURL
        : "", // IF URL redio button checekd then pass URL else keep it blank
      contact_us: marketPlaceListingValues.contactUsURL
        ? marketPlaceListingValues.contactUsURL
        : "", // IF URL redio button checekd then pass URL else keep it blank
      head_line: `${marketPlaceListingValues.headline}`,
      description: `${description}`,

      // category: `${category[categoryIndex]}`,
      // category_id: `${categoryIndex}`, // Hidden as per requirements due to add static value like revnue cycle

      confirmation_page_type:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? "Confirmation Page"
          : "Redirect to Partner Page", // if redio yes selected then value should be 'Confirmation Page' else value should be 'Redirect to Partner Page'
      thank_you_note:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? `${thankYouNote}`
          : marketPlaceListingValues.redirectToPartnerPageURL, //if radio button yes selected then Thank you note for user if radio button No selected then Redirect to partner page URL
      thank_you_note_header:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? `${marketPlaceListingValues.confirmationPageHeader}`
          : "", // IF redio yes selected then Confirmation page header line if redio no selected then blank
      confirmation_page_partner_url:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? ""
          : "Redirect to partner page URL", //if redio button yes selected then blank else value of Redirect to partner page URL
      img_bytes_confirmation_image:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? marketPlaceListingValues.confirmationImage !== "Default"
            ? confirmationImage[0]?.base64?.split(",")[1]
            : ""
          : "", //if redio button yes selected and upload image then bytes else blank
      img_name_confirmation_image:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? marketPlaceListingValues.confirmationImage !== "Default"
            ? confirmationImage[0]?.path
            : ""
          : "", //if redio button yes selected and upload image then name else blank
      confirmation_email_header: marketPlaceListingValues.confirmationEmailHeaderLine
        ? `${marketPlaceListingValues.confirmationEmailHeaderLine}`
        : "",
      confirmation_email: contentConfirmationEmail
        ? `${contentConfirmationEmail}`
        : "",
      automatic_registration_handshake: `${
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx]
      }`, //drop down
      for_support:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? ""
          : marketPlaceListingValues.forSupport, //if yes selected in dropdown then blank
      for_registration:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? ""
          : marketPlaceListingValues.forRegistration, //if yes selected in dropdown then blank
      post_url_for_new_purchase:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? marketPlaceListingValues.postURLForNewPurchase
          : "", //if No selected in dropdown then blank
      post_url_for_cancellation:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? marketPlaceListingValues.postURLForPartnerCancellation
          : "", //if No selected in dropdown then blank
      post_api_body_type: marketPlaceListingValues.postApiBodyType
        ? `${marketPlaceListingValues.postApiBodyType}`
        : "",
      post_api_fields: marketPlaceListingValues.postApiFields
        ? marketPlaceListingValues.postApiFields.toString()
        : "", //selected checkbox
      partner_id: partnerId ? partnerId : "", // You need to check the response of partner_all_apps API and if any of the apps has value in publish_app_partner_id field then pass it
      receive_earning_type: "Not Applicable", //Fixed value
      add_updated_by: loginUserDetails.user_name,
      // ............................

      need_api_license: needSikkaAppsLicense.value,
      api_license: apiLicenseValue,
      logo_url: partnerlogoImage.replace("data:image/png;base64,", ""),
      tagline: partnerTagline,
      create_support_ticket:
        selectedFreshdeskOptionValue?.selectedFreshdeskOption?.value,
      support_ticket_email:
        selectedFreshdeskOptionValue?.selectedFreshdeskOptionForNotification
          ?.value,
    };

    let updateBody = {
      partner_id: partnerId ? partnerId : "",
      service_domain:
        marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.length > 0
            ? marketPlaceListingValues.domain[0]
            : "--"
          : marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.toString()
          : "--",
      description: `${description}`,

      terms_of_service: marketPlaceListingValues.termsOfServiceURL
        ? marketPlaceListingValues.termsOfServiceURL
        : "--", // IF URL redio button checekd then pass URL else keep it blank
      cancellation_policy: marketPlaceListingValues.cancellationPolicyURL
        ? marketPlaceListingValues.cancellationPolicyURL
        : "--", // IF URL redio button checekd then pass URL else keep it blank
      privacy_policy: marketPlaceListingValues.privacyPolicyURL
        ? marketPlaceListingValues.privacyPolicyURL
        : "--", // IF URL redio button checekd then pass URL else keep it blank
      contact_us: marketPlaceListingValues.contactUsURL
        ? marketPlaceListingValues.contactUsURL
        : "--",
      img_confirm_image_empty:false,
      confirmation_page_type:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? "Confirmation Page"
          : "Redirect to Partner Page",
      confirmation_email_header: marketPlaceListingValues.confirmationEmailHeaderLine
        ? `${marketPlaceListingValues.confirmationEmailHeaderLine}`
        : "--",
      thank_you_note:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? `${thankYouNote}`
          : marketPlaceListingValues.redirectToPartnerPageURL,
      automatic_registration_handshake: `${
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx]
      }`,
      thank_you_note_header:
        marketPlaceListingValues.redirectToConfirmationPage === "Yes"
          ? `${marketPlaceListingValues.confirmationPageHeader}`
          : "--",

      for_support:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? "--"
          : marketPlaceListingValues.forSupport, //if yes selected in dropdown then blank
      for_registration:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? "--"
          : marketPlaceListingValues.forRegistration,

      post_url_for_new_purchase:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? marketPlaceListingValues.postURLForNewPurchase
          : "--", //if No selected in dropdown then blank
      post_url_for_cancellation:
        automaticRegistrationHandshake[automaticRegistrationHandshakeIdx] ===
        "Yes"
          ? marketPlaceListingValues.postURLForPartnerCancellation
          : "--",
      post_api_body_type: marketPlaceListingValues.postApiBodyType
        ? `${marketPlaceListingValues.postApiBodyType}`
        : "--",
      post_api_fields: marketPlaceListingValues.postApiFields
        ? marketPlaceListingValues.postApiFields.toString()
        : "--",

      service_name: `${
        removeRandomLastString(selectedApplication.app_name).removeRandomString
      }`,
      head_line: `${marketPlaceListingValues.headline}`,
      domain_name:
        marketPlaceListingValues.domain.length > 0
          ? marketPlaceListingValues.domain.toString()
          : "--",

      create_support_ticket:
        selectedFreshdeskOptionValue?.selectedFreshdeskOption?.value,
      support_ticket_email:
        selectedFreshdeskOptionValue?.selectedFreshdeskOptionForNotification
          ?.value,
      need_api_license: needSikkaAppsLicense.value,
      api_license: apiLicenseValue,
      confirmation_email: contentConfirmationEmail,
      dev_id: `${loginUserDetails.parent_dev_id}`,
      add_updated_by: loginUserDetails.user_name,
    };

    if (!isEditMode) {
      APICall.servertrip(
        "POST",
        "publish_application",
        loginUserDetails,
        undefined,
        addBody
      ).then(
        (res) => {
          toast.success("Application successfully published");
          sessionStorage.removeItem("publish-app-details");
          window.location.reload();
          setisClicked(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          window.location.reload();
          setisClicked(false);
        }
      );
    } else {
      if (selectedApplication.publish_app_service_id) {
        updateBody["service_id"] = selectedApplication.publish_app_service_id;
      }
      if (selectedApplication.publish_app_partner_id) {
        updateBody["partner_id"] = selectedApplication.publish_app_partner_id;
      }
      if (promotionalImage1[0]?.path) {
        updateBody["img_name_promotional1"] = promotionalImage1[0]?.path;
        updateBody["img_promotional1"] = promotionalImage1[0]?.base64?.split(
          ","
        )[1];
      }
      if (promotionalImage2[0]?.path) {
        updateBody["img_name_promotional2"] = promotionalImage2[0]?.path;
        updateBody["img_promotional2"] = promotionalImage2[0]?.base64?.split(
          ","
        )[1];
      }
      if (promotionalImage3[0]?.path) {
        updateBody["img_name_promotional3"] = promotionalImage3[0]?.path;
        updateBody["img_promotional3"] = promotionalImage3[0]?.base64?.split(
          ","
        )[1];
      }
      if (marketplaceBackgroundImage[0]?.path) {
        updateBody["img_marketplace_background_image_name"] =
          marketplaceBackgroundImage[0]?.path;
        updateBody[
          "img_marketplace_background_image"
        ] = marketplaceBackgroundImage[0]?.base64?.split(",")[1];
      }

      if (confirmationImage == "Default") {
        updateBody["img_name_confirmation_image"] = "";
        updateBody["img_confirmation_image"] = "";
        updateBody["img_confirm_image_empty"] = true;
      }
      if (confirmationImage[0]?.path) {
        updateBody["img_name_confirmation_image"] = confirmationImage[0]?.path;
        updateBody[
          "img_confirmation_image"
        ] = confirmationImage[0]?.base64?.split(",")[1];
      }
      APICall.servertrip(
        "PUT",
        "update_publish_app_details",
        loginUserDetails,
        undefined,
        updateBody
      ).then(
        (res) => {
          toast.success("Application updated successfully.");
          sessionStorage.removeItem("publish-app-details");
          window.location.reload();
          setisClicked(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          window.location.reload();
          setisClicked(false);
        }
      );
    }
  };

  return (
    <Card>
      <SikkaCardHeader
        title={"Publish your application on Sikka Marketplace"}
      />
      <CardBody>
        <Row>
          <Col className="d-flex flex-column align-items-center">
            <p className="fs--1">
              Please confirm your application details before publishing it to
              Sikka Marketplace.
            </p>
            <Button
              color="primary"
              disabled={isClicked}
              size="sm"
              onClick={handlePublishApplication}
            >
              {!isClicked
                ? isEditMode
                  ? "Update published App"
                  : "Publish"
                : " Please Wait..."}
              {/* <Link
                to={{
                  pathname: `billing`,
                  state: { defaultKey: "payment" },
                }}
                className="text-light"
                style={{ textDecoration: "none" }}
              >
                Publish
              </Link> */}
            </Button>
            <p className="mt-3 fs--1">
              Note: Please goto https://www.sikkasoft.com to see your published
              application. You can distribute your application url to your
              user/customer to signup for your app.
            </p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FinalPublish;
